import api from '../../../services/Api';
import { IAuditoriaSimCapitalResultado } from '../interfaces/IAuditoriaSimCapital';

export const AuditoriaSimCapitalService = {
  buscarResultado: async (params: { empresaId: number; periodo: string | undefined })
    : Promise<IAuditoriaSimCapitalResultado> => {
    const response = await api.get<IAuditoriaSimCapitalResultado>(
      'auditoria-sim-capital/resultado',
      { params: { empresaIds: params.empresaId, periodo: params.periodo } }
    );
    return response.data;
  },
};
